import { inject, Injectable } from '@angular/core';
import { MessageService } from 'primeng/api';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  private messageService = inject(MessageService);
  private translate = inject(TranslateService);

  addSuccess(mess: {
    severity?: string;
    title?: string;
    detail: string;
    sticky?: boolean;
  }) {
    this.messageService.add({
      key: 'br',
      severity: mess.severity || 'success',
      summary: mess.title || this.translate.instant('common.success'),
      detail: mess.detail,
      sticky: mess.sticky === undefined ? false : mess.sticky,
    });
  }

  addWarn(mess: {
    severity?: string;
    title?: string;
    detail: string;
    sticky?: boolean;
  }) {
    this.messageService.add({
      key: 'br-warn',
      severity: mess.severity || 'warn',
      summary: mess.title || this.translate.instant('common.warning'),
      detail: mess.detail,
      sticky: mess.sticky === undefined ? false : mess.sticky,
    });
  }

  addError(mess: {
    severity?: string;
    title?: string;
    detail: string;
    sticky?: boolean;
  }) {
    this.messageService.add({
      key: 'br-error',
      severity: mess.severity || 'error',
      summary: mess.title || this.translate.instant('common.error'),
      detail: mess.detail || this.translate.instant('common.pleaseTryAgain'),
      sticky: mess.sticky === undefined ? false : mess.sticky,
    });
  }

  clearErrors() {
    this.messageService.clear('br-error');
  }
}
